import React, { Component } from "react";
import { Spinner } from "reactstrap";
import { FaShoppingBasket } from 'react-icons/fa';

export default class CartIcon extends Component {
  renderBadgeContent() {
    return (
      <div className="d-flex justify-content-center align-items-center w-100 h-100">
        {this.props.waiting ? (
          <Spinner type="grow" style={{ width: '0.5rem', height: '0.5rem' }} />
        ) : (
          this.props.number
        )}
      </div>
    );
  }



  render() {
    const isEmptyOrWaiting = this.props.waiting || this.props.number === 0;
    const badgeClass = isEmptyOrWaiting ? 'badge-custom-secondary' : 'badge-custom-danger';

    return (
      <div className="position-relative d-inline-block justify-content-center align-items-center">
        <FaShoppingBasket size={20} />
        <span
          className={`position-absolute top-0 start-100 translate-middle badge rounded-pill ${badgeClass}`}
        >
          {this.renderBadgeContent()}
        </span>
      </div>
    );
  }
}
